export type LoadExternalScriptOptions = {
  id: string;
  src: string;
  async?: boolean;
  defer?: boolean;
  type?: string;
};

export const loadExternalScript = ({ id, src, async = true, defer, type }: LoadExternalScriptOptions) => {
  return new Promise<void>((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Document is not available.'));
      return;
    }

    const existingScript = document.getElementById(id) as HTMLScriptElement | null;

    if (existingScript) {
      if (existingScript.getAttribute('src') !== src) {
        reject(new Error(`Script with id "${id}" already exists with a different source.`));
        return;
      }

      // If a matching script already exists, resolve immediately to make loadExternalScript idempotent.
      // Past load/error events won't fire again, so we can't reliably wait for them.
      existingScript.dataset.loaded = 'true';
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = async;
    if (defer !== undefined) {
      script.defer = defer;
    }
    if (type) {
      script.type = type;
    }
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = () => {
      script.remove();
      reject(new Error(`Failed to load script: ${src}`));
    };

    document.body.appendChild(script);
  });
};
